import { type CouponBoardIdentifiers, couponBoardValidator } from '../../../../schema/coupon/entry.js';
import type { IUpdateCouponBoardUseCase } from '../../../domain/entry.js';

export type IUpdateCouponBoardController = ReturnType<typeof updateCouponBoardController>;

// Map values to "unknown" to be more API-like
type CouponBoardPayload = Pick<
  {
    [K in keyof ReturnType<typeof couponBoardValidator.parse>]: unknown;
  },
  'quickPickSize' | 'outcomes' | 'uOutcomes' | 'mOutcomes' | 'reduction'
>;

/**
 * Controller for updating a coupon.
 *
 * @param updateCouponBoardUseCase Use case for updating a coupon
 * @returns Controller executor function
 */
export function updateCouponBoardController(updateCouponBoardUseCase: IUpdateCouponBoardUseCase) {
  return async function controller(
    payload: CouponBoardPayload,
    { couponId, couponIndex, boardIndex }: CouponBoardIdentifiers
  ): Promise<number> {
    const parsedPayload = couponBoardValidator.parse(payload);
    return await updateCouponBoardUseCase.execute({ couponId, couponIndex, boardIndex, payload: parsedPayload });
  };
}
